import { JsonApiLink } from '@/api/json-api.types';

/**
 * Interface con el mapeo de los endpoints
 * 
 * El mapeo contiene la key del endpoint y el value es un objeto de tipo JsonApiLink
 */
export interface CAEndpointsState {
  endpoints_map: Map<string, JsonApiLink>;
}

// Mutation de mapeo de endpoints
export const ENDPOINT_MUTATION_AGREGAR: string = 'agregarEndpoint';

// Getter de mapeo de endpoints
export const ENDPOINT_GETTER: string = 'obtenerEndpoint';

